"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceUnavailableError = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_validator_1 = require("class-validator");
const HttpError_1 = require("./HttpError");
class ServiceUnavailableError extends HttpError_1.HttpError {
    constructor(error = 'A service was unavailable') {
        super(503, 'service_unavailable', error);
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ defaultValue: 503, description: 'HTTP Code' }),
    tslib_1.__metadata("design:type", Number)
], ServiceUnavailableError.prototype, "statusCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: 'service_unavailable', description: 'HTTP Status' }),
    tslib_1.__metadata("design:type", String)
], ServiceUnavailableError.prototype, "code", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        example: 'A service was unavailable',
        description: 'A service was unavailable',
    }),
    tslib_1.__metadata("design:type", String)
], ServiceUnavailableError.prototype, "message", void 0);
exports.ServiceUnavailableError = ServiceUnavailableError;
